export * from './rubrique-dialog.component';